const setMemberStatus = payload => {
  return {
    type: "memberStatus",
    payload
  };
};

export default setMemberStatus;
